<template>
  <div class="modal-body">
    <div
      class="modal-body--alert alert alert-danger d-none"
      role="alert"
    />
    <div class="row h-100 w-100">
      <div
        class="modal-body--preview col-6"
      >
        <img
          v-if="currentFile.data.thumbnail"
          class="modal-body--preview__img"
          :src="currentFile.data.thumbnail | share"
          alt="preview"
          @load="handlePreviewLoaded"
        >
        <div
          class="spinner-border modal-body--preview__spinner"
          :class="{'d-none': !isPreviewLoading}"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <FigmaLayersTree
        class="modal-body--layers-wrapper col-6"
        :tree="currentFile.data.tree"
      />
    </div>
    <div class="row w-100 justify-content-end">
      <button
        v-if="isCreatingNewTemplates"
        type="button"
        class="btn btn-primary"
        :disabled="isImporting"
        @click="handleTemplatesImport"
      >
        <span
          v-if="isImporting"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
        Add to template
      </button>
    </div>
  </div>
</template>

<script>
import FigmaLayersTree from "@frontend/components/modules/figma-layers/FigmaLayersTree.vue";
import {createNamespacedHelpers} from "vuex";
import share from "@frontend/components/modules/figma-layers/mixins/share";
import {FigStrategy} from "@frontend/group/modules/fig-layers/strategy";

const { mapGetters, mapActions } = createNamespacedHelpers('figmaLayers')

export default {
  name: 'FigmaLayerSelector',
  components: {FigmaLayersTree},
  mixins: [share],
  data() {
    return {
      isPreviewLoading: true,
    }
  },
  computed: {
    ...mapGetters([
      'flow', 
      'currentFile',
      'isImporting'
    ]),
    isCreatingNewTemplates() {
      return this.flow === FigStrategy.FLOWS.CREATE_TEMPLATES;
    }
  },
  methods: {
    ...mapActions([
      'handleTemplatesImport',
    ]),
    handlePreviewLoaded() {
      this.isPreviewLoading = false;
    }
  }
}
</script>
